import React, { useEffect } from 'react';

function AlertMessage({ message, type = "success", duration = 1000 }) {
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const alertDiv = document.getElementById("alert-container");
            if (alertDiv) {
                alertDiv.style.opacity = 0; // Animation de disparition (par exemple, fondu)
                setTimeout(() => alertDiv.remove(), 500); // Suppression finale après fondu (ajuster au besoin)
            }
        }, duration);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [duration]);

    return (
        message && (
            <div id="alert-container">
                <div
                    className={`alert alert-${type} alert-dismissible fade show`}
                    role="alert"
                    style={{ transition: "opacity 0.5s ease" }}
                >
                    {message}
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => document.getElementById("alert-container").remove()}
                        data-bs-dismiss="alert"
                        aria-label="Close"
                    ></button>
                </div>
            </div>
        )
    );
}

export default AlertMessage;